/**
 * Module dependencies.
 */

import { Background, Image, Wrapper } from './portfolio-header.style';
import { JSX } from 'react';

/**
 * Export `PortfolioHeader` component.
 */

export function PortfolioHeader(): JSX.Element {
  return (
    <>
      <Wrapper>
        <Background>
          <Image src={'/portfolio_bg.jpg'} />
        </Background>
      </Wrapper>
    </>
  );
}
